import React, { useEffect, useState } from 'react';
import baseURL from '../baseURL';
import GirviPageShell from '../components/common/GirviPageShell';

const DebugAccounting = () => {
  const [entries, setEntries] = useState([]);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchAllEntries = async () => {
    setLoading(true);
    setError('');
    try {
      const token = localStorage.getItem('token');
      console.log('🔍 Debug: Fetching all accounting entries');
      
      const res = await fetch(`${baseURL}/accounting-entries/debug-all`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      console.log('🔍 Debug: Response status:', res.status);
      
      if (!res.ok) {
        const errorText = await res.text();
        console.error('🔍 Debug: Error response:', errorText);
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      
      const data = await res.json();
      console.log('🔍 Debug: All entries data:', data);
      
      setEntries(data.entries || []);
      setData(data);
      console.log('🔍 Debug: Total ledgers:', data.totalLedgers);
      console.log('🔍 Debug: Sample ledgers:', data.sampleLedgers);
    } catch (err) {
      console.error('🔍 Debug: Error fetching entries:', err);
      setError('Failed to fetch entries.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllEntries();
  }, []);

  return (
    <GirviPageShell
      title="Debug Accounting"
      subtitle="Transactions · Tools"
      chipLabel="Transactions"
      maxWidth="xl"
    >
      <button onClick={fetchAllEntries} disabled={loading}>
        {loading ? 'Loading...' : 'Refresh'}
      </button>
      
      {error && <p style={{ color: 'red' }}>{error}</p>}
      
      {loading ? <p>Loading...</p> : (
        <div>
          <h3>Total Entries: {entries.length}</h3>
          <h4>Total Ledgers: {data?.totalLedgers || 'N/A'}</h4>
          {data?.sampleLedgers && (
            <div>
              <h4>Sample Ledgers:</h4>
              <ul>
                {data.sampleLedgers.map((ledger, idx) => (
                  <li key={idx}>
                    ID: {ledger._id} | Code: {ledger.code} | Name: {ledger.name} | Group: {ledger.groupCode}
                  </li>
                ))}
              </ul>
            </div>
          )}
          <table border="1" cellPadding="6" style={{ width: '100%', borderCollapse: 'collapse', background: '#fff' }}>
            <thead style={{ background: '#f0f0f0' }}>
              <tr>
                <th>Date</th>
                <th>Source</th>
                <th>Description</th>
                <th>Amount</th>
                <th>Type</th>
                <th>Ledger ID</th>
                <th>Ledger Code</th>
                <th>Ledger Name</th>
                <th>Group Code</th>
                <th>Ticket No</th>
              </tr>
            </thead>
            <tbody>
              {entries.length === 0 && (
                <tr><td colSpan={10} style={{ textAlign: 'center' }}>No entries found.</td></tr>
              )}
              {entries.map((entry, idx) => (
                <tr key={idx}>
                  <td>{new Date(entry.date).toLocaleDateString()}</td>
                  <td>{entry.source}</td>
                  <td>{entry.description}</td>
                  <td style={{ textAlign: 'right' }}>{entry.amount?.toFixed(2)}</td>
                  <td>{entry.transactionType}</td>
                  <td style={{ fontSize: '10px' }}>{entry.ledgerId || 'null'}</td>
                  <td>{entry.ledgerCode}</td>
                  <td>{entry.ledgerName}</td>
                  <td>{entry.ledgerGroupCode}</td>
                  <td>{entry.ticketNo}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </GirviPageShell>
  );
};

export default DebugAccounting; 